// extracted by mini-css-extract-plugin
export default {"galleryHeader":"c-p_fU"};